import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=4af852b2&scoped=true&"
import script from "./CalendarMonth.vue?vue&type=script&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&lang=js&"
import style0 from "./CalendarMonth.vue?vue&type=style&index=0&id=4af852b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af852b2",
  null
  
)

export default component.exports